import { UserBase, UserBaseMailPermission } from "@/commons/interfaces";
import { inject, InjectionKey, provide, reactive, ref } from "vue";
import { SidUserClient } from "@sid/sid_client";

const MailPermissionItemKey: InjectionKey<MailPermissionItem> = Symbol("MailPermissionItem");

export class MailPermissionItem {

    public static create(...dummy: any[]) {
        return new MailPermissionItem();
    }

    public static inject(): MailPermissionItem {
        const info = inject(MailPermissionItemKey);
        if (info) {
            return info;
        }
        throw new Error("not provided.");
    }

    public readonly mailPermission = reactive(new UserBaseMailPermission())

    public readonly agreement = ref(false);

    public setMailPermission(userMailPermissionVal: UserBaseMailPermission) {
        this.mailPermission.identityId = userMailPermissionVal.identityId;
        this.mailPermission.userName = userMailPermissionVal.userName;
        this.mailPermission.mailPermissionInfo = Object.assign({}, userMailPermissionVal.mailPermissionInfo);
        this.mailPermission.manageInfo = Object.assign({}, userMailPermissionVal.manageInfo);
    }

    public async fetch(sidClient: SidUserClient) {
        const response = await sidClient.requestApi({ method: "GET", path: "/user/mail_permission" }).then(res => res.data).catch(e => new UserBaseMailPermission());
        this.setMailPermission(response);
        return response;
    }

    public provide() {
        provide(MailPermissionItemKey, this);
    }
}